import PlaylistDto from "types/PlaylistDto";
import Timeline from "types/Timeline";

export const scope = "PlaylistManagement";
const createPlaylistManagement = (set, get) => ({
  setValue: (key, value) => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: { ...get()[scope], [key]: value },
      }),
      false,
      `[${scope}.setValue](${key}, ${JSON.stringify(value)}) `,
    );
  },

  handleFormChange: (key, value) => {
    set(
      (store) => ({
        ...store,
        [scope]: {
          ...store[scope],
          formPlaylist: { ...store[scope].formPlaylist, [key]: value },
        },
      }),
      false,
      `${scope} : handleFormChange`,
    );
  },

  formPlaylist: {
    id: null,
    title: "",
    notes: "",
    videos: [],
    createdOn: "",
  },
  isFormPlaylistChange: false,

  playlistDetails: {},
  setPlaylistDetails: (playlistDetails) => {
    set(
      (store) => {
        store[scope].playlistDetails = {
          ...store[scope].playlistDetails,
          ...playlistDetails,
        };
        return store;
      },
      false,
      `${scope} : setPlaylistDetails`,
    );
  },

  timelinesByPlaylistId: {},
  hasTimelineChange: false,
  getTimelineByPlaylistId: (playlistId: string): Timeline => {
    return (
      get()[scope].timelinesByPlaylistId[playlistId] || {
        playlistId,
        timelineItems: [],
      }
    );
  },
  setTimeline: (timeline: Timeline) => {
    set(
      (store) => {
        store[scope].timelinesByPlaylistId[timeline.playlistId] = timeline;
        return store;
      },
      false,
      `${scope} : setHasTimelineChange`,
    );
  },
  setHasTimelineChange: (hasTimelineChange: boolean) => {
    set(
      (store) => {
        store[scope].hasTimelineChange = hasTimelineChange;
        return store;
      },
      false,
      `${scope} : setHasTimelineChange`,
    );
  },
  setTimelinesByPlaylistId: (timelinesByPlaylistId) => {
    set(
      (store) => {
        store[scope].timelinesByPlaylistId = timelinesByPlaylistId;
        return store;
      },
      false,
      `[${scope}.setTimelinesByPlaylistId]`,
    );
  },

  byId: {},
  selectedPlaylists: [],
  setSelectedPlaylists: (playlists) => {
    set(
      (state) => {
        state[scope].selectedPlaylists = playlists;
        return state;
      },
      false,
      `${scope} : selectedPlaylists`,
    );
  },

  playlists: [],
  setNewPlaylistById: (playlist: PlaylistDto) => {
    set(
      (state) => {
        state[scope].byId[playlist.id] = playlist;
        return state;
      },
      false,
      `${scope} : setNewPlaylistById`,
    );
  },

  showEditableTimelinePlayer: false,
});

export default createPlaylistManagement;
